import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  IconButton,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons"; 
import GradientButton from 'components/Buttons/GradientButton.js';

const headerBgImage = require('../../assets/img/longarrow.jpg');

const ReusableModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title, 
    bodyMessage, 
    confirmLabel = "Confirm", 
    cancelLabel = "Close", 
    confirmDisabled = false,
    showConfirmButton = true, // Control visibility of Confirm button
    showCancelButton = true,  // Control visibility of Cancel button
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="12px">
        <Box
          bgImage={`url(${headerBgImage})`} // Use the image as a background
          bgSize="cover"
          bgPosition="center"
          p={4}
          position="relative"
          borderTopLeftRadius="12px"
          borderTopRightRadius="12px"
        >
          <IconButton
            aria-label="Close"
            icon={<CloseIcon />}
            onClick={onClose}
            position="absolute"
            top={-1}
            right={-3}
            mt={3}
            mr={5}
            borderRadius="full"
            bg="white"
            color="#071D54"
            _hover={{ bg: "gray.200" }}
            size="xs"
          />
          <ModalHeader fontSize="md" fontWeight="700" color="white" py={1}>
            {title}
          </ModalHeader>
        </Box>

        <ModalBody p={4}>
          {bodyMessage}
        </ModalBody>

        <ModalFooter>
          {showCancelButton && (
            <GradientButton onClick={onClose} fontSize={"14px"} height={"40px"} width={"90px"}>
              {cancelLabel}
            </GradientButton>
          )}
          {showConfirmButton && (
            <GradientButton
              onClick={() => {
                onConfirm();
                onClose();
              }}
              ml={showCancelButton ? 3 : 0} // Add margin if both buttons are present
              fontSize={"14px"} height={"40px"} width={"90px"}
              isDisabled={confirmDisabled}
            >
              {confirmLabel}
            </GradientButton>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ReusableModal;
